import axios from './BaseService';

const API_URL = process.env.REACT_APP_API_URL;

export async function doLogin(username, password) {
  const loginURL = `${API_URL}/login`;
  const response = await axios.post(
    loginURL,
    { username, password },
    {
      withCredentials: true, //sem essa linha o token não é salvo nos cookies
    },
  );
  return response.data;
}
